"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeProviderType = void 0;
exports.IkeProviderType = {
    BEARING_BACK: 'backbearing',
    BEARING: 'bearing',
    EXISTING_SPAN: 'existingspan',
    GPS: 'gps',
    MANUAL: 'manual',
    EDITED: 'edited',
    POINT_TO_POINT: 'pointtopoint',
    SAG: 'sag',
    COLLECTION: 'collection',
};
//# sourceMappingURL=provider.js.map